import React, { useState, useRef, useEffect } from "react";

const BeforeAfterSlider = ({ before, after }) => {
  const [sliderPosition, setSliderPosition] = useState(50); // Default in the middle
  const containerRef = useRef(null);
  const isDragging = useRef(false);

  const handleDrag = (event) => {
    if (!isDragging.current || !containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();

    // Ensure event.touches exists before accessing it
    const clientX = event.touches ? event.touches[0]?.clientX : event.clientX;
    if (clientX === undefined) return; // Prevents the crash

    let newPosition = ((clientX - rect.left) / rect.width) * 100;

    if (newPosition < 0) newPosition = 0;
    if (newPosition > 100) newPosition = 100;

    setSliderPosition(newPosition);
  };

  const startDragging = () => {
    isDragging.current = true;
  };

  const stopDragging = () => {
    isDragging.current = false;
  };

  useEffect(() => {
    const handleMouseMove = (e) => handleDrag(e);
    const handleTouchMove = (e) => handleDrag(e);

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", stopDragging);
    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("touchend", stopDragging);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", stopDragging);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", stopDragging);
    };
  }, []);

  return (
    <div ref={containerRef} className="relative w-full max-w-3xl mx-auto h-80 rounded-lg overflow-hidden shadow-lg no-select">
      {/* Before Image */}
      <img src={before} alt="Before" className="absolute top-0 left-0 w-full h-full object-cover no-drag" />

      {/* After Image with Clipping */}
      <div
        className="absolute top-0 left-0 h-full no-select"
        style={{
          width: "100%",
          clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`,
        }}
      >
        <img src={after} alt="After" className="w-full h-full object-cover no-drag" />
      </div>

      {/* Draggable Handle */}
      <div
        className="absolute top-0 left-0 h-full flex items-center cursor-ew-resize no-select"
        style={{ left: `${sliderPosition}%` }}
        onMouseDown={startDragging}
        onTouchStart={startDragging}
      >
        {/* Line */}
        <div className="w-1 h-full bg-white opacity-75"></div>

        {/* Drag Circle */}
        <div className="absolute top-1/2 left-[-10px] w-6 h-6 bg-white border-2 border-gray-500 rounded-full transform -translate-y-1/2 shadow-md"></div>
      </div>
    </div>
  );
};

export default BeforeAfterSlider;
